// extracted by mini-css-extract-plugin
module.exports = {"colMin":"styles_colMin__1V1_g","colCheckbox":"styles_colCheckbox__CKG50"};